/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCrop = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M7 2v2.999h12v12h3V19h-3v3h-2v-3H5L4.999 6.999H2V5h2.999V2zm0 4.999v10h10v-10z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCrop as Crop };
